import { configureStore } from '@reduxjs/toolkit';
import { signupApi } from '../services/signupApi';
import signupReducer from './signupSlice';
import uiReducer from './uiSlice';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    signup: signupReducer,
    ui: uiReducer,
    auth: authReducer,
    [signupApi.reducerPath]: signupApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['signup/addEmail/fulfilled'],
        ignoredPaths: ['signup.lastSignup.timestamp'],
      },
    }).concat(signupApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 